import React from 'react'
import Payroll from '../Components/Payroll/Payroll'

const PayrollManagementPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <Payroll/>
    </div>
  )
}

export default PayrollManagementPage
